import { useState } from "react";
import { Alert, Box, Chip, CircularProgress, Collapse, Container, IconButton, Paper, Stack, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs, Typography, } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { useGetInquiries } from "../generated/queries/queries"; // adjust to wherever your generated hooks live
import React from "react";
const STATUS_OPTIONS = ["all", "new", "contacted", "booked", "archived"];
function InquiryRow({ inquiry }) {
    const [open, setOpen] = useState(false);
    return (React.createElement(React.Fragment, null,
        React.createElement(TableRow, { hover: true },
            React.createElement(TableCell, { sx: { width: 40 } },
                React.createElement(IconButton, { size: "small", onClick: () => setOpen((prev) => !prev) }, open ? React.createElement(KeyboardArrowUpIcon, null) : React.createElement(KeyboardArrowDownIcon, null))),
            React.createElement(TableCell, null,
                inquiry.first_name,
                " ",
                inquiry.last_name),
            React.createElement(TableCell, null, inquiry.email),
            React.createElement(TableCell, null, inquiry.location),
            React.createElement(TableCell, null, inquiry.date_description),
            React.createElement(TableCell, null,
                React.createElement(Stack, { direction: "row", spacing: 0.5, flexWrap: "wrap", useFlexGap: true }, (inquiry.interests ?? []).map((type) => (React.createElement(Chip, { key: type.id, label: type.display_label, size: "small" }))))),
            React.createElement(TableCell, null,
                React.createElement(Chip, { label: inquiry.status, 
                    // color={STATUS_COLORS[inquiry!.status!] ?? "default"}
                    size: "small" })),
            React.createElement(TableCell, null, inquiry.submitted_at
                ? new Date(inquiry.submitted_at).toLocaleDateString()
                : "—")),
        React.createElement(TableRow, null,
            React.createElement(TableCell, { colSpan: 8, sx: { py: 0, borderBottom: open ? undefined : "none" } },
                React.createElement(Collapse, { in: open, timeout: "auto", unmountOnExit: true },
                    React.createElement(Box, { sx: { py: 2, px: 2 } },
                        React.createElement(Typography, { variant: "subtitle2", gutterBottom: true }, "Message"),
                        React.createElement(Typography, { variant: "body2", sx: { mb: 1, whiteSpace: "pre-wrap" } }, inquiry.message),
                        React.createElement(Typography, { variant: "caption", color: "text.secondary" },
                            "Heard about via: ",
                            inquiry.hear_about_me)))))));
}
export default function InquiryDashboard() {
    const [statusFilter, setStatusFilter] = useState("all");
    // react-query handles loading/error/caching — same pattern as the
    // inquiry-types fetch in InquiryForm.
    const { data: inquiries = [], isLoading, error } = useGetInquiries();
    const filtered = statusFilter === "all"
        ? inquiries
        : inquiries.filter((inquiry) => inquiry.status === statusFilter);
    return (React.createElement(Container, { maxWidth: "lg", sx: { py: 4 } },
        React.createElement(Typography, { variant: "h4", gutterBottom: true }, "Inquiries"),
        React.createElement(Tabs, { value: statusFilter, onChange: (_, value) => setStatusFilter(value), sx: { mb: 2 } }, STATUS_OPTIONS.map((status) => (React.createElement(Tab, { key: status, label: status, value: status })))),
        isLoading && (React.createElement(Box, { sx: { display: "flex", justifyContent: "center", py: 4 } },
            React.createElement(CircularProgress, null))),
        error && (React.createElement(Alert, { severity: "error", sx: { mb: 2 } },
            "Couldn't load inquiries: ",
            error.message)),
        !isLoading && !error && (React.createElement(TableContainer, { component: Paper },
            React.createElement(Table, { size: "small" },
                React.createElement(TableHead, null,
                    React.createElement(TableRow, null,
                        React.createElement(TableCell, null),
                        React.createElement(TableCell, null, "Name"),
                        React.createElement(TableCell, null, "Email"),
                        React.createElement(TableCell, null, "Location"),
                        React.createElement(TableCell, null, "Date"),
                        React.createElement(TableCell, null, "Interested In"),
                        React.createElement(TableCell, null, "Status"),
                        React.createElement(TableCell, null, "Submitted"))),
                React.createElement(TableBody, null, filtered.length === 0 ? (React.createElement(TableRow, null,
                    React.createElement(TableCell, { colSpan: 8, align: "center", sx: { py: 4 } },
                        "No inquiries",
                        statusFilter !== "all"
                            ? ` with status "${statusFilter}"`
                            : "",
                        "."))) : (filtered.map((inquiry) => (React.createElement(InquiryRow, { key: inquiry.id, inquiry: inquiry }))))))))));
}
